<template>
  <div>
    <div class="header_wrapper">
      <a-tabs type="card"
              v-model="currentTab"
              @change="changeTab">
        <a-tab-pane v-for="tab in tabList"
                    :key="tab.path"
                    :tab="tab.title">
        </a-tab-pane>
      </a-tabs>
    </div>
    <keep-alive>
      <router-view/>
    </keep-alive>

  </div>
</template>

<script>
export default {
  name: 'Express',
  data() {
    return {
      tabList: [],
      currentTab: ''
    }
  },
  computed: {},
  created() {
    this.tabList = this.getTabList()
  },
  methods: {
    getTabList() {
      var list = [
        {
          title: "寄快递",
          path: "/express/send"
        },
        {
          title: "快递管理",
          path: "/express/manage"
        },
        {
          title: "运费计算",
          path: "/express/freight"
        },
        {
          title: "快递账户管理",
          path: "/express/account"
        },
        {
          title: "快递批量导入",
          path: "/express/import"
        }
      ];
      return list
    },
    changeTab(path) {
      this.$router.push({path})
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.currentTab = route.matched[0].path
        if(route.matched[0].path=='/express/logistics'){
          this.currentTab = "/express/manage"
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.header_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;
  border-bottom: 1px solid #fd5902;
}

.small_tip {
  font-size: 12px;
  color: #fd5902;
  padding-left: 20px;
  padding-bottom: 10px;
}

.header_wrapper >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar {
  border-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/functions/express/components/ExpressTips.vue